import { useMemo } from "react";
import { useSelector } from "react-redux";
import { QueryParamType, useParseQueryParams } from "@b2bportal/core-utilities";
import { CarsAvailabilitySelectors } from "~core-cars/store";
import { CAR_URL_PARAM_KEYS } from "~core-cars/utilities";

export const useShopPageRoute = () => {
  const params = useParseQueryParams({
    [CAR_URL_PARAM_KEYS.SHOP_ID]: {
      type: QueryParamType.requiredString,
    },
  });

  const { data: availability } = useSelector(
    CarsAvailabilitySelectors.getAvailabilityResponse
  );
  const dayCount = useSelector(CarsAvailabilitySelectors.getSearchDayCount);

  const car = useMemo(() => {
    if (availability == null || dayCount == null || params.shopId == null) {
      return null;
    }

    const maybeCar = availability.vehicles.find(
      (c) => c.vehicle.id === params.shopId
    );

    if (maybeCar == null) return null;

    return {
      ...maybeCar,
      supplier: availability.context.suppliers[maybeCar.supplierRef],
    };
  }, [availability, dayCount, params.shopId]);

  const shopRequest = useMemo(() => {
    if (car == null || availability == null) {
      return null;
    }

    return {
      opaqueShopRequestContext: availability.context.opaqueShopRequestContext,
      opaqueShopRequestVehicle: car.opaqueShopRequest,
    };
  }, [availability, car]);

  return car != null && shopRequest != null && dayCount != null
    ? { params, car, dayCount, shopRequest }
    : null;
};
